import _ from 'lodash';
import { CancelToken } from 'axios';
import { OmnitechApi } from '../../api';
import { cancelRequest } from '../../helpers'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

export function fetchStaffs(options = {}) {
  const { role = 'teacher', page = 1, ...others } = options
  const params = {
    page,
    ...others
  }
  const source = CancelToken.source()
  cancelRequest.add(
    'fetchStaffs',
    () => source.cancel('fetchStaffs: Operation cancelled by user')
  )

  return OmnitechApi
    .request({
      endpoint: `staffs/${role}`,
      method: 'get',
      params,
      CancelToken: source.token,
      arrayFormat: 'brackets'
    })
    .catch(error => {
      if (cancelRequest.isCancel(error)) {
        throw cancelRequest.getErrorObject()
      }
      throw convertResponseToErrorObject(_.get(error, 'response.data'), { useResponseMessage: true })
    })
    .then(response => {
      if (isErrorExist(response.data)) throw convertResponseToErrorObject(response.data, { useResponseMessage: true })
      return response.data
    })
    .then(({ data }) => ({
      staffs: _.get(data, 'staffs', {}),
      next: _.get(data, 'staffsPagination.nextPage') > page
        ? () => fetchStaffs({
          page: page + 1,
          ...others
        })
        : null,
      all:
        page === 1 && data.staffsPagination.totalPages > 1
          ? () =>
            Promise.all(
              _.times(data.staffsPagination.totalPages - 1, index =>
                fetchStaffs({ ...params, pageCountless: true, page: index + 2 }),
              ),
            )
          : null,
      count: _.get(data, 'staffsPagination.totalCount')
    }))
};
